document.querySelectorAll('.pkg_price, .pkg_save_ammount, .atc_price').forEach(function (element) {
  element.style.display = '';
});

function postJson(url, data, callbacks = {}) {
  const body = new URLSearchParams();

  Object.keys(data || {}).forEach(function (key) {
    body.append(key, data[key]);
  });

  if (typeof callbacks.beforeSend === 'function') {
    callbacks.beforeSend();
  }

  return fetch(url, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
    body: body.toString(),
  })
    .then(function (response) {
      if (!response.ok) {
        throw response;
      }

      return response.json();
    })
    .then(function (data) {
      if (typeof callbacks.success === 'function') {
        callbacks.success(data);
      }

      return data;
    })
    .catch(function (error) {
      if (typeof callbacks.error === 'function') {
        callbacks.error(error);
      }

      throw error;
    });
}

function getJson(url, callback) {
  return fetch(url, {
    headers: {
      Accept: 'application/json',
    },
  })
    .then(function (response) {
      if (!response.ok) {
        throw response;
      }

      return response.json();
    })
    .then(function (data) {
      if (typeof callback === 'function') {
        callback(data);
      }

      return data;
    });
}
if (sessionStorage.getItem("bundleToken") != null) {
  var token=sessionStorage.getItem("bundleToken");
  postJson('/cart/clear.js', {
      token: token
    }, {
    success: function(response) {
      sessionStorage.removeItem(token);
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.querySelector("#cart-icon-bubble .cart-count-bubble")?.remove();
    }
  });
}

function returnElement(element){
  return document.querySelector(element);
}

function returnElements(element){
  return document.querySelectorAll(element);
}

function getVisibleProductSettings() {
  return returnElement(".product_settings:not([hidden]) .product-setting-box");
}

function getVariantData(productSettings) {
  return Array.from(productSettings.querySelectorAll('.hidden-input')).map(function (input) {
    const variant = {
      input: input,
      available: input.dataset.available === 'true',
      id: input.value.split('/').pop(),
    };

    Object.keys(input.dataset).forEach(function (key) {
      if (key.indexOf('option') === 0) {
        variant[key] = input.dataset[key];
      }
    });

    return variant;
  });
}

function getCurrentSelections(productSettings) {
  const selections = {};

  productSettings.querySelectorAll('.variant-input-wrap').forEach(function (fieldset, index) {
    const checkedInput = fieldset.querySelector('input[data-variant-input]:checked');
    if (checkedInput) {
      selections['option' + (index + 1)] = checkedInput.value;
    }
  });

  return selections;
}

function updateVariantAvailability(productSettings) {
  if (!productSettings) return;

  const variants = getVariantData(productSettings);
  const selections = getCurrentSelections(productSettings);

  productSettings.querySelectorAll('.variant-input-wrap').forEach(function (fieldset, index) {
    const optionKey = 'option' + (index + 1);
    const checkedInput = fieldset.querySelector('input[data-variant-input]:checked');

    fieldset.querySelectorAll('input[data-variant-input]').forEach(function (input) {
      const candidateSelections = Object.assign({}, selections, {
        [optionKey]: input.value,
      });

      const hasAvailableVariant = variants.some(function (variant) {
        if (!variant.available) return false;

        return Object.keys(candidateSelections).every(function (selectionKey) {
          return !candidateSelections[selectionKey] || variant[selectionKey] === candidateSelections[selectionKey];
        });
      });

      input.disabled = !hasAvailableVariant;
      input.classList.toggle('is-unavailable', !hasAvailableVariant);
      input.nextElementSibling?.classList.toggle('is-unavailable', !hasAvailableVariant);
      input.nextElementSibling?.setAttribute('aria-disabled', String(!hasAvailableVariant));
    });

    if (checkedInput && checkedInput.disabled) {
      const firstAvailableInput = fieldset.querySelector('input[data-variant-input]:not(:disabled)');
      if (firstAvailableInput) {
        firstAvailableInput.checked = true;
      }
    }
  });
}

function setCaseSelection(caseElement, shouldActivate) {
  const caseSelection = caseElement?.closest('.case_selection');
  const caseBox = caseElement?.closest('.casbox');
  const button = caseBox?.querySelector('.btn-box');

  if (!caseSelection || !caseBox || !button) return;

  caseSelection.querySelector('.single_case.active')?.classList.remove('active');
  caseSelection.querySelector('.btn-box.active')?.classList.remove('active');

  if (shouldActivate) {
    caseElement.classList.add('active');
    button.classList.add('active');
  }

  getCurrentVariant();
}

const gift_products = document.querySelectorAll(".gift-imges .variantImage");
if(gift_products.length > 0){
  gift_products.forEach(function(e){
    e.addEventListener("click",function(){
      this.closest(".gift-imges").querySelector(".variantImage.active")?.classList.remove("active");
      this.classList.add("active");
    })
  })
}

const tabTriggers = document.querySelectorAll("button.tablinks");

if(tabTriggers.length > 0){
  tabTriggers.forEach(function(element){
    element.addEventListener("click",function(){
      const value = this.getAttribute('data-collection-handle');
      const tabs = returnElements(".tabcontent");
      tabs.forEach(function(e){e.setAttribute('hidden','true')});
      returnElement('.tabcontent[collection-handle="'+value+'"]').removeAttribute('hidden');
      tabTriggers.forEach(function(e){e.classList.remove('active')});
      this.classList.add('active');

      const activeProduct = returnElement(".tabcontent:not([hidden]) .tab_prod_container.tab_prod_container_active");
      const activeId = activeProduct.getAttribute('data-id');
      returnElement(".product_settings:not([hidden])").setAttribute("hidden",true);
      returnElement(".product_settings[data-product-id='"+activeId+"']").removeAttribute("hidden");

      activateRooster();

      getCurrentVariant();
    });
  })
}

function convertToShopifyPrice(price) {
  const numericPrice = parseFloat(price);

  if (isNaN(numericPrice)) {
    return "Invalid price";
  }

  const formattedPrice = numericPrice.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  });

  return formattedPrice;
}
function getCurrentVariant(){
  updateVariantAvailability(getVisibleProductSettings());

  const variantTitle = findVariant();
  const variantInput = findVariantInput(variantTitle);
  if(!variantInput){
    cartTextChange("Sold Out",true);
    return;
  }
  if(variantInput.classList.contains("not-available")){
    cartTextChange("Sold Out",true);
  }
  else{
    cartTextChange("Subscribe Now",false);
  }
  const variantCurrentId = variantInput.value.split('/').pop();
  const variantPriceInput = variantInput.closest('.product-setting-box').querySelector(".variantPrice[variant-id='"+variantCurrentId+"']");
  const variantPrice = Number(variantPriceInput.value);
  const variantPrice2 = Number(variantPriceInput.value);
  let variantDPrice = Number(variantPriceInput.getAttribute('variant-delivery-price'));
  const priceDifference = variantPrice - variantDPrice;

  const caseElement = returnElement(".case_selection_box:not([hidden]) .single_case.active");
  if(caseElement){
    variantDPrice += Number(caseElement.getAttribute('data-price'));
  }
  setTimeout(function(){
    const roosterOptions = returnElements(".rooster_options:not([hidden]) .rooster_selection");
    let roosterValue = "";
    if(roosterOptions.length > 0){
      roosterOptions.forEach(function(e,index){
         roosterValue = roosterValue + e.querySelector("input:checked")?.value.replace(' ','-').toLowerCase();
        if((index+1) < roosterOptions.length){
          roosterValue = roosterValue + '-';
        }
      })
    }

  const foundedRoosterElement = document.querySelector(".freeRooster.active .roster-input[value*='"+roosterValue+"']");
  if(!caseElement){
  if(foundedRoosterElement){
    variantDPrice += Number(foundedRoosterElement.getAttribute("variant-price"));
  }}
const pckgPrice = returnElements(".selling_plan_box .pkg_price");
pckgPrice.forEach(function(e){
  const discountedPrice = variantPrice2 * 0.75;
  e.innerText = convertToShopifyPrice(discountedPrice);
});

const saveEle = returnElements(".selling_plan_box .pkg_save_ammount");
saveEle.forEach(function(e){
  const priceDifference = variantPrice2 - (variantPrice2 * 0.75);
  e.innerText = "Save " + convertToShopifyPrice(priceDifference);
});

returnElement('button.atc_btn .atc_price').innerText = convertToShopifyPrice(variantDPrice);
}, 100);

}
function cartTextChange(buttonText,buttonState){
  const addToCartButton = returnElement("button.atc_btn");
  returnElement("button.atc_btn .atc_button_inner > span").innerText = buttonText;
  addToCartButton.classList.toggle("disabled", buttonState);
  addToCartButton.disabled = buttonState;
}

const variantInputs = returnElements(".variant_selector_box input[data-variant-input]");
if(variantInputs.length > 0){
  variantInputs.forEach(function(e){e.addEventListener("change",function(){
    updateVariantAvailability(this.closest('.product-setting-box'));
    getCurrentVariant();
  })})
}
getCurrentVariant();

function activateRooster(){
  const activeTabLink = returnElement("button.tablinks.active").getAttribute('data-id');

  returnElement(".rooster_options:not([hidden])").setAttribute("hidden",true);
  returnElement(".rooster_options[data-id='"+activeTabLink+"']").removeAttribute("hidden");
}
activateRooster();

const allImgtrigger = returnElements('[imgtrigger]');
if(allImgtrigger.length > 0){
  allImgtrigger.forEach(function(element){
    element.addEventListener("click",function(){
      const productId = this.getAttribute('data-id');
      this.closest('.tabcontent').querySelector(".tab_prod_container.tab_prod_container_active").classList.remove('tab_prod_container_active');
      this.classList.add('tab_prod_container_active');
      returnElement(".product_settings:not([hidden])").setAttribute("hidden",true);
      returnElement(".product_settings[data-product-id='"+productId+"']").removeAttribute("hidden");

      getCurrentVariant();
    })
  })
}

const sellingPlans = returnElements('.package_container');
if(sellingPlans.length > 0){
  sellingPlans.forEach(function(element){
    element.addEventListener("click",function(){
      const currentIndex = Number(this.getAttribute('data-index'));
      const allProducts = returnElements('.product-setting-box');
      allProducts.forEach(function(e){
        const planInput = e.querySelector('.sellingPlan').value.split(',');
        const currentPlan = planInput[currentIndex];
        const variantInputs = e.querySelectorAll(".hidden-input");
        variantInputs.forEach(function(e){
          e.setAttribute('data-selling_plans',currentPlan);
        })
      })
      returnElement('.package_container.active').classList.remove("active");
      this.classList.add('active');

      getCurrentVariant();
    })
  })
}

const caseTrigger = returnElements(".single_case");
if(caseTrigger.length > 0){
  caseTrigger.forEach(function(e){
    e.addEventListener("click",function(){
      const isActive = this.classList.contains('active');
      setCaseSelection(this, !isActive);
    })
  })
}

const freeRoosterOption_trigger = document.querySelectorAll(".freeRangeRoster_options input");
if(freeRoosterOption_trigger.length > 0){
  freeRoosterOption_trigger.forEach(function(e){
   e.addEventListener("change",function(){
    getCurrentVariant();
  })
  })
}

function findVariant(variantTitle = ""){
  const foundProduct = returnElements(".product_settings:not([hidden]) .variant-input-wrap");
  foundProduct.forEach(function(e,index){
    variantTitle = variantTitle + e.querySelector('input:checked').value.toLowerCase().replace(' ','-');
    if((index+1) < foundProduct.length){
      variantTitle = variantTitle + '-';
    }
  });
  return variantTitle;
}

function findVariantInput(variantTitle){
  const variantParent = returnElement('.product_settings:not([hidden])');
  return variantParent.querySelector("input.hidden-input[value*='"+variantTitle+"']");;
}

const addToCart = returnElement('button.atc_btn');
addToCart.addEventListener("click",function(){
  if (this.disabled || this.classList.contains('disabled')) {
    return;
  }

  let variantTitle = findVariant();
  const variantInput = findVariantInput(variantTitle);
  const selling_plan = Number(variantInput.getAttribute("data-selling_plans"));
  const variant_id = Number(variantInput.value.split('/').pop());

  const comProduct = returnElement(".case_selection_box:not([hidden]) .single_case.active");
  const wantComProduct = comProduct ? true : false;

  const roosterProduct = document.querySelector(".freeRooster.active .roster-input[value*='"+variantTitle+"']");
  const wantRooster = roosterProduct ? true : false;

  function roosterAjax(){
    if(wantRooster){
      const rooster_Id = Number(roosterProduct.value.split('/').pop());
      postJson("/cart/add.js", {
        quantity: 1,
        id: rooster_Id,
      }, {
        success: function (data) {
          cartUpdate();
        },
      });
    }else{
      cartUpdate();
    }
  }

  function cartUpdate(){
    getJson('/cart.js', function(cart) {
      sessionStorage.setItem("bundleToken", cart.token);
      location.href = "/checkout?discount=XXAA5VD73135,ZSAVJY3G4VHK";
      setTimeout(function(){
        returnElement("button.atc_btn").disabled = false;
      },3000)
    });
  }

  postJson("/cart/add.js", {
      quantity: 1,
      id: variant_id,
      selling_plan: selling_plan,
    }, {
    beforeSend: function(){
      returnElement("button.atc_btn").disabled = true;
    },
    success: function (data) {

      const giftContainer = returnElement(".sec_1_right_item3 .gift_container .variantImage.active");
      if(giftContainer){
        postJson("/cart/add.js", {
            quantity: 1,
            id: Number(giftContainer.getAttribute("data-variant")),
          }, {
          success: function (data) {
            compartmentSend();
          },
          error: function(){
            compartmentSend();
          },
        });
      }else{
        compartmentSend();
      }
      function compartmentSend(){
        if(wantComProduct){
          const comProduct_id = Number(comProduct.getAttribute('data-variant'));
          postJson("/cart/add.js", {
              quantity: 1,
              id: comProduct_id,
            }, {
            success: function (data) {
              roosterAjax();
            },
          });
        }else{
          roosterAjax();
        }
      }
    },
    error: function(){
      returnElement("button.atc_btn").disabled = false;
    },
  });
});
document.querySelectorAll('.btn-box').forEach(function (button) {
  button.addEventListener('click', function () {
    const caseElement = this.closest('.casbox')?.querySelector('.single_case');
    const isActive = this.classList.contains('active');
    setCaseSelection(caseElement, !isActive);
  });
});

document.querySelectorAll('.mobile-opacity .load-more-box a').forEach(function (link) {
  link.addEventListener('click', function () {
    this.closest('.mobile-opacity')?.classList.remove('mobile-opacity');
  });
});
      function toggleActiveClass(boxId) {
            const box = document.getElementById(boxId);
            const button = box.querySelector("button");
            box.classList.toggle("active");

            if (box.classList.contains("active")) {
                button.textContent = "Added";
            } else {
                button.textContent = "Add " + "+";
            }
        }

        document.getElementById("men_box").addEventListener("click", function () {
            toggleActiveClass("men_box");
            toggleActiveClass("men_rooster");
        });

        document.getElementById("women_box").addEventListener("click", function () {
            toggleActiveClass("women_box");
            toggleActiveClass("women_rooster");
        });

const packageContainers = document.querySelectorAll('.package_container');
const single_case_container =document.querySelectorAll('.single_case');
const variantImage_container = document.querySelectorAll('.variantImage');

function handleClassChange(mutationsList) {
    mutationsList.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const packageContainer = mutation.target;
            const parentElement = packageContainer.parentElement;

            if (packageContainer.classList.contains('active')) {
                parentElement.classList.add('active_package');
            } else {
                parentElement.classList.remove('active_package');
            }
        }
    });
}

const observer = new MutationObserver(handleClassChange);

packageContainers.forEach((container) => {
    observer.observe(container, { attributes: true });
});
single_case_container.forEach((container) => {
    observer.observe(container, { attributes: true });
});
variantImage_container.forEach((container) => {
    observer.observe(container, { attributes: true });
});
